export enum ActivityType {
  ScopeSubmitted = 27,
  ScopeNote = 28,
  ScopeDate = 29,
  ScopeDocument = 30,
  ScopeClosed = 31,
  ScopeDecision = 32,
  ScopeApplicationAssignment = 33,
  ScopeAdditionalEvidenceRequest = 34,
  ScopeAdditionalEvidenceSubmitted = 35,
  ScopeChanged = 40,
  ScopeMessageOfqual = 41,
  ScopeMessageAo = 42,
  ScopeWithdrawn = 43,
}
